<template>
    <div>
        <page-header title="Profile information"/>
        <div class="container">
            <content-loader v-if="!loggedIn" title="Profile"/>
            <div v-else>
                <div class="card">
                    <!-- <div class="card-header">
                        Profile Detail
                        <button type="button" :class="`btn  btn-sm rightFloat ${isEdit?'btn-secondary':'btn-primary'}`" @click="isEdit=!isEdit" >{{isEdit?"Cancel":"Edit"}}</button>
                    </div> -->
                    <!-- <profile-edit :user="user" :submitFunction="saveProfile" v-if="isEdit"/> -->
                    <profile-view :user="user"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $auth from "@/services/auth.js";
import getProfileDetail from '@/gql/GetProfileDetail.gql';
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader'
import ProfileView from '@/components/profile/ProfileView'
import ProfileEdit from '@/components/profile/ProfileEdit'
import UpdateProfile from '@/gql/UpdateProfile.gql';
export default {
    name: 'profile',

    components: {
        PageHeader,
        ContentLoader,
        ProfileView,
        ProfileEdit
    },
    data() {
        return{
            loggedIn:false,
            user:{},
            isEdit: false
        }
    },
    async beforeCreate(){
        var user = await $auth.user()
        if(user){
            this.loggedIn = true
            this.user = user
        }
        else{
            this.$router.push('login');
        }
    },
    methods: {
        saveProfile(data) {
            console.log("hey", data)
            this.$apollo.mutate({
            mutation: UpdateProfile,
            variables: data
            }).then(userData=>{
                console.log("userData", userData.data)
                this.user = userData.data.UpdateProfile.returning[0]
                this.isEdit = false
            })
        }
    }
}
</script>

<style scoped>
    .title {
        font-weight: 700;
        font-size: 18px;
    }

    .detail {
        font-size: 18px;
    }
    .rightFloat {
        float: right;
    }
    .container{
        padding-bottom: 20px;
    }
</style>
